import React from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import theme from "../../index.scss";
import Sallie from "../../images/sallie-oops.png";
import SubmitButton from "../UIComponents/SubmitButton";

const Oops = () => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <Row
      style={{ color: theme.teal }}
      className="d-flex justify-content-center text-center"
    >
      <Col>
        <Row>
          <Col>
            <h2>{t("oops.header")}</h2>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col xs={8} md={4}>
            <img
              style={{ objectFit: "cover", maxWidth: "100%" }}
              alt="Apologetic Dog"
              src={Sallie}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <h4>{t("oops.subheading")}</h4>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col md={6}>
            <p style={{ color: "initial" }}>{t("oops.body")}</p>
          </Col>
        </Row>
        <Row className="d-flex flex-column align-items-center">
          <SubmitButton onClick={() => history.push("/")}>
            {t("helppage.go_back")}
          </SubmitButton>
          <SubmitButton onClick={() => history.push("/help")}>
            {t("oops.request_help")}
          </SubmitButton>
        </Row>
      </Col>
    </Row>
  );
};

export default Oops;